<div class="login-panel-container">
    <div class="login-panel cc-login-panel">
        <div class="login-container">
            <dx-responsive-box width="100%" height="100%">
                <dxi-row></dxi-row>
                <dxi-row></dxi-row>
                <dxi-col></dxi-col>
                <dxi-item>
                    <dxi-location [row]="0" [col]="0"></dxi-location>
                    <div *dxTemplate class="logo-container">
                        <img
                            [ngClass]="{ logo: !isSmallScreen, 'logo-small': isSmallScreen }"
                            [src]="logoImage"
                            alt="CiraConnect Logo"
                        />
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="1" [col]="0"></dxi-location>
                    <div *dxTemplate class="cc-login-portal-header">
                        <div
                            [ngClass]="{
                                'login-portal-header': !isSmallScreen,
                                'login-portal-header-small': isSmallScreen
                            }"
                        >
                            MANAGEMENT / BOARD PORTAL
                        </div>
                    </div>
                </dxi-item>
            </dx-responsive-box>
            <div>
                <router-outlet></router-outlet>
            </div>
        </div>
        <app-welcome-message></app-welcome-message>
    </div>
</div>
